import {useLocation, useNavigate} from "react-router-dom";
import {
    checkboxCss,
    indexWrapCss,
    formInputCss
} from "./../css/Books.style";
import Header from "../../../common/layouts/header/Header";
import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import Footer from "../../../common/layouts/footer/Footer";
import axios from "axios";
import DatePicker from "react-datepicker";
import {ko} from "date-fns/locale";
import {ReactComponent as Search} from 'src/assets/search.svg';
import BookOptionalSection from '../components/BookOptionalSection';
import {useIsMobile} from "../../../hooks/useIsMobile";
import { optionalCharError, creativeProcessError } from 'src/common/utils/charValidation';


interface FormErrors {
    title? : string;
    desc? : string;
    cover? : string;
    catalyst? : string;
    index? : string;
    keyword1? : string;
    keyword2? : string;
    keyword3? : string;
    keywordRes1? : string;
    keywordRes2? : string;
    keywordRes3? : string;
    genre1? : string;
    genre2?:  string;
    planBackground?: string;
    creativeProcessText?: string;
    differenceFromPrev?: string;
    readerMessage?: string;
    toneDecisionProcess?: string;

}



const BookUpdate = () => {

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    const navigate = useNavigate();

    const [visibleMonth, setVisibleMonth] = useState<Date>(new Date());
    const [search, setSearch] = useState("");

    const location = useLocation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const { bookData } = location.state || {};

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    //book add form List
    const [bookTitle, setBookTitle] = useState<string>("");
    const [bookCoverPreview, setBookCoverPreview] = useState<string | undefined>(undefined);
    const [bookCover, setBookCover] = useState<string | undefined>(undefined);
    const fileBookCoverRef = useRef<HTMLInputElement | null>(null);
    const [image, setImage] = useState<string | null>(null);
    const [showImageCrop, setShowImageCrop] = useState(false);
    const [bookDescription, setBookDescription] = useState<string>("");
    const [catalyst, setCatalyst] = useState<string>("")

    const [keyword1, setKeyWord1] = useState<string>("");
    const [keyword2, setKeyWord2] = useState<string>("");
    const [keyword3, setKeyWord3] = useState<string>("");

    const [bookIndex, setBookIndex] = useState<string>("");

    const [keywordReason1, setKeywordReason1] = useState<string>("");
    const [keywordReason2, setKeywordReason2] = useState<string>("");
    const [keywordReason3, setKeywordReason3] = useState<string>("");


    const genre = ['시' , '소설' , '에세이' , '인문', '자기 계발', '엽서/일러스트레이션 북', ];

    const [genre1, setGenre1] = useState<string>("");
    const [genre2, setGenre2] = useState<string>("");


    const [selectedGenre, setSelectedGenre] = useState<string[]>([]);
    const [currentGenre, setCurrentGenre] = useState<string>('');
    const [currentGenre2, setCurrentGenre2] = useState<string>('');
    const [genreCheck, setGenreCheck] = useState<boolean>(false)
    const isMobile = useIsMobile();

    // 추가 선택 항목
    const [planBackground, setPlanBackground] = useState<string>("");
    const [creativeProcessText, setCreativeProcessText] = useState<string>("");
    const [differenceFromPrev, setDifferenceFromPrev] = useState<string>("");
    const [readerMessage, setReaderMessage] = useState<string>("");
    const [toneDecisionProcess, setToneDecisionProcess] = useState<string>("");

    // 이미지 (업데이트 페이지에서도 추가 이미지 수정을 원할 수 있으므로)
    // 단, 현재 UI에는 추가 이미지 업로드 버튼이 OptionalSection에 없으므로 텍스트 위주로 처리하거나 추후 확장

    //수상 내역
    const [noAward, setNoAward] = useState(false);
    const [awardBookTitle, setAwardBookTitle] = useState<string>("");
    const [awardDate, setAwardDate] = useState<Date | null>(null);

    // 작품 구매 링크
    const [bookLink, setBookLink] = useState<string>("");
    const [isUrlVerified, setIsUrlVerified] = useState<boolean>(false);
    const [isVerifyingUrl, setIsVerifyingUrl] = useState<boolean>(false);
    const [urlVerificationMessage, setUrlVerificationMessage] = useState<any>(null);
    const bookLinkRef = useRef<HTMLInputElement>(null);


    useEffect(() => {
        if (bookData) {
            // 초기 값 세팅


            setBookTitle(bookData.bookTitle || "");
            setBookCoverPreview(bookData.coverImage || "");
            setBookCover(bookData.coverImage || "");
            setBookDescription(bookData.bookDescription || "");
            setCatalyst(bookData.bookPublicationReason || "");
            setKeyWord1(bookData.keyword1 || "");
            setKeyWord2(bookData.keyword2 || "");
            setKeyWord3(bookData.keyword3 || "");
            setBookIndex(bookData.bookIndex || "");
            setKeywordReason1(bookData.keyword1Reason || "");
            setKeywordReason2(bookData.keyword2Reason || "");
            setKeywordReason3(bookData.keyword3Reason || "");
            setGenre1(bookData.genre1 || "");
            setGenre2(bookData.genre2 || "");

            const initialGenres = [];

            if (bookData.genre1) initialGenres.push(bookData.genre1);
            if (bookData.genre2) initialGenres.push(bookData.genre2);

            setSelectedGenre(initialGenres);


            setCurrentGenre(bookData.genre1 || "");
            setCurrentGenre2(bookData.genre2 || "");
            if (bookData.genre1 || bookData.genre2) {
                setGenreCheck(true); // 이미 장르가 선택되었다면, 오류를 방지
            }


            if (bookData.bookAwardDate) {
                const parsedAwardDate = new Date(bookData.bookAwardDate);
                if (!isNaN(parsedAwardDate.getTime())) {
                    setAwardDate(parsedAwardDate);
                } else {
                    console.error("Invalid date format");
                }
            }
            setAwardBookTitle(bookData.bookAwardTitle || "");
            setAwardDate(bookData.bookAwardDate || null);

            // 추가 정보 세팅
            setPlanBackground(bookData.planningBackground || "");
            setCreativeProcessText(bookData.creationProcess || "");
            setDifferenceFromPrev(bookData.differenceFromPreviousWork || "");
            setReaderMessage(bookData.messageToReaders || "");
            setToneDecisionProcess(bookData.toneDecisionProcess || "");
            setBookLink(bookData.bookLink || "");
            if (bookData.bookLink) {
                setIsUrlVerified(true); // 기존 링크가 있으면 이미 인증된 것으로 간주 (또는 재인증 유도 가능)
            }
        }
    }, [bookData]);


    const getImageSrc = () => {
         if (bookCover) {
            // bookCover가 이미 data:image/... 형태인지 확인
            return bookCover.startsWith('data:image')
                ? bookCover
                : `data:image/png;base64,${bookCover}`; // 없으면 붙여줌
        } else {
            return '';
        }
    };


    const handleGenreChange = (genreItem: string) => {
        setSelectedGenre((prevSelectedGenres) => {
            if (prevSelectedGenres.includes(genreItem)) {
                return prevSelectedGenres.filter((item) => item !== genreItem); // 장르 해제
            } else {
                return [...prevSelectedGenres, genreItem]; // 장르 추가
            }
        });
    };

    const handleUrlValidation = async () => {
        if (!bookLink) {
            alert("검증할 URL을 입력해주세요.");
            return;
        }
        setIsVerifyingUrl(true);
        setUrlVerificationMessage(null);
        try {
            const response = await axios.post('/api/book/validate-url', { url: bookLink });
            const data = response.data;
            setUrlVerificationMessage(data);
            if (data.reachable) {
                setIsUrlVerified(true);
            } else {
                setIsUrlVerified(false);
            }
        } catch (error) {
            console.error("URL validation error:", error);
            setIsUrlVerified(false);
            setUrlVerificationMessage({ message: "URL 검증 중 오류가 발생했습니다.", reachable: false });
        } finally {
            setIsVerifyingUrl(false);
        }
    };

    const toggleKeyword = (keyword: string) => {
        let newGenreCheck = genreCheck;
        let newGenre1 = currentGenre;
        let newGenre2 = currentGenre2;

        if (currentGenre === '' && keyword !== currentGenre2) {
            setCurrentGenre(keyword);
            setGenreCheck(true);
            newGenreCheck = true;
            newGenre1 = keyword;
        } else if (currentGenre2 === '' && keyword !== currentGenre) {
            setCurrentGenre2(keyword); // 장르 2 선택
            newGenreCheck = true;
            newGenre2 = keyword;
        } else if (currentGenre === keyword) {
            setCurrentGenre('');
            newGenre1 = '';
            if (currentGenre2 === '') {
                setGenreCheck(false);
                newGenreCheck = false;
            }
        } else if (currentGenre2 === keyword) {
            setCurrentGenre2('');
            newGenre2 = '';
            if (currentGenre === '') {
                setGenreCheck(false);
                newGenreCheck = false;
            }
        } else {
            alert("두 개의 장르만 선택할 수 있습니다.");
            return;
        }

        if (!newGenreCheck) {
            setErrors(prev => ({ ...prev, genre1: "*최소 1개의 장르는 필수로 선택해야 합니다" }));
        } else {
            setErrors(prev => {
                const { genre1, ...rest } = prev;
                return rest;
            });
        }
    };


    //etc.. ...
    const [errorMessage, setErrorMessage] = useState('');

    const checkKeyWord = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if(index === 1 ) {
            setKeyWord1(value);
            validateField('keyword1', value);
        } else if (index === 2) {
            setKeyWord2(value);
            validateField('keyword2', value);
        } else {
            setKeyWord3(value);
            validateField('keyword3', value);
        }
    }

    const [errors, setErrors] = useState<FormErrors>({});

    const validateField = (name: keyof FormErrors, value: any) => {
        let errorMsg = '';
        switch(name) {
            case 'title':
                if (!value) errorMsg = "*제목을 입력해 주세요.";
                else if (value.length > 20) errorMsg = "*최대 20자까지 입력해 주세요.";
                break;
            case 'cover':
                if (!value) errorMsg = "*필수 항목입니다.";
                break;
            case 'index':
                if (value.length < 20) errorMsg = "*최소 20자 이상 작성해 주세요.";
                break;
            case 'desc':
                if (value.length < 200) errorMsg = "*최소 200자 이상 작성해 주세요.";
                break;
            case 'catalyst':
                if (value.length < 50) errorMsg = "*최소 50자 이상 작성해 주세요 .";
                break;
            case 'keyword1':
                if (!value) errorMsg = "*필수 항목입니다.";
                else if (value.length > 10) errorMsg = "최대 10자까지 작성 가능합니다.";
                break;
            case 'keywordRes1':
                if (value.length < 50) errorMsg = "*최소 50자 이상 작성해 주세요.";
                break;
            case 'keyword2':
                if (!value) errorMsg = "*필수 항목입니다.";
                else if (value.length > 10) errorMsg = "최대 10자까지 작성 가능합니다.";
                break;
            case 'keywordRes2':
                if (value.length < 50) errorMsg = "*최소 50자 이상 작성해 주세요.";
                break;
            case 'keyword3':
                if (!value) errorMsg = "*필수 항목입니다.";
                else if (value.length > 10) errorMsg = "최대 10자까지 작성 가능합니다.";
                break;
            case 'keywordRes3':
                if (value.length < 50) errorMsg = "*최소 50자 이상 작성해 주세요.";
                break;
            default:
                break;
        }

        setErrors(prev => {
            if (errorMsg) {
                return { ...prev, [name]: errorMsg };
            } else {
                const { [name]: _, ...rest } = prev;
                return rest;
            }
        });
    };
    const titleRef = useRef<HTMLInputElement>(null);
    const genreRef = useRef<HTMLButtonElement>(null);
    const keywordRef1 = useRef<HTMLInputElement>(null);
    const keywordRef2 = useRef<HTMLInputElement>(null);
    const keywordRef3 = useRef<HTMLInputElement>(null);
    const keywordResRef1 =  useRef<HTMLTextAreaElement>(null);
    const keywordResRef2 =  useRef<HTMLTextAreaElement>(null);
    const keywordResRef3 =  useRef<HTMLTextAreaElement>(null);
    const descRef =  useRef<HTMLTextAreaElement>(null);
    const catalystRef =  useRef<HTMLTextAreaElement>(null);
    const indexRef  =  useRef<HTMLTextAreaElement>(null);
    const [selectedGenres, setSelectedGenres] = useState<string[]>([]);


    const handleCheckboxChange = (genre: string) => {
        setSelectedGenres((prevSelected) =>
            prevSelected.includes(genre)
                ? prevSelected.filter((item) => item !== genre)
                : [...prevSelected, genre]
        );
    };

    const validateCheck = (): boolean => {

        const newErrors: FormErrors = {};

        if(!bookTitle) {
            newErrors.title = "*제목을 입력해 주세요."
            titleRef.current?.focus()
        } else if (bookTitle.length > 20) {
            newErrors.title = "*최대 20자까지 입력해 주세요."
            titleRef.current?.focus()
        } else if(!genreCheck) {
            newErrors.genre1 = "*최소 1개의 장르는 필수로 선택해야 합니다"
            genreRef.current?.focus()
        } else if (!bookCoverPreview) {
            newErrors.cover = "*필수 항목입니다."
            fileBookCoverRef.current?.focus()
        } else if (bookIndex.length < 20) {
            newErrors.index = "*최소 20자 이상 작성해 주세요."
            indexRef.current?.focus()
        } else if (bookDescription.length < 200) {
            newErrors.desc = "*최소 200자 이상 작성해 주세요."
            descRef.current?.focus()
        } else if (!catalyst && catalyst.length < 50) {
            newErrors.catalyst = "*최소 50자 이상 작성해 주세요 ."
            catalystRef.current?.focus()
        } else if (!keyword1) {
            newErrors.keyword1 = "*필수 항목입니다."
            keywordRef1.current?.focus()
        } else if (keyword1.length > 10) {
            newErrors.keyword1 = "최대 10자까지 작성 가능합니다."
            keywordRef1.current?.focus()
        } else if (keywordReason1.length <50) {
            newErrors.keywordRes1 = "*최소 50자 이상 작성해 주세요."
            keywordResRef1.current?.focus()
        }  else if (!keyword2) {
            newErrors.keyword2 = "*필수 항목입니다."
            keywordRef2.current?.focus()
        } else if (keyword2.length > 10) {
            newErrors.keyword2 = "최대 10자까지 작성 가능합니다."
            keywordRef2.current?.focus()
        } else if ( keywordReason2.length <50) {
            newErrors.keywordRes2 = "*최소 50자 이상 작성해 주세요."
            keywordResRef2.current?.focus()
        } else if (!keyword3) {
            newErrors.keyword3 = "*필수 항목입니다."
            keywordRef3.current?.focus()
        }  else if (keyword3.length > 10) {
            newErrors.keyword3 = "최대 10자까지 작성 가능합니다."
            keywordRef3.current?.focus()
        } else if (keywordReason3.length <50) {
            newErrors.keywordRes3 = "*최소 50자 이상 작성해 주세요."
            keywordResRef3.current?.focus()
        } else if (optionalCharError(planBackground)) {
            newErrors.planBackground = optionalCharError(planBackground) || "";
        } else if (creativeProcessError(creativeProcessText)) {
            newErrors.creativeProcessText = creativeProcessError(creativeProcessText) || "";
        } else if (optionalCharError(differenceFromPrev)) {
            newErrors.differenceFromPrev = optionalCharError(differenceFromPrev) || "";
        } else if (optionalCharError(readerMessage)) {
            newErrors.readerMessage = optionalCharError(readerMessage) || "";
        } else if (optionalCharError(toneDecisionProcess)) {
            newErrors.toneDecisionProcess = optionalCharError(toneDecisionProcess) || "";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }


    const formatDate = (date: Date): string | null => { // date를 Date 객체로 받기

        if (!(date instanceof Date) || isNaN(date.getTime())) {
            console.error("유효하지 않은 날짜입니다.");
            return null;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };



    const [bookRegSubmitButtonClick, setBookRegSubmitButtonClick] = useState(false)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!validateCheck()) return;

        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            alert('로그인 상태를 확인해주세요.');
            return;
        }

        const formData = new FormData();
        formData.append('bookTitle', bookTitle)
        formData.append('bookDescription', bookDescription)
        formData.append('catalyst', catalyst)
        formData.append('bookLink', bookLink)

        formData.append('bookAwardTitle', awardBookTitle)

        if(awardDate) {
            const formattedDate  = formatDate(awardDate);
            if (formattedDate) {
                formData.append('bookAwardDate', formattedDate);
            }
        }

        formData.append('keyword1', keyword1)
        formData.append('keyword2', keyword2)
        formData.append('keyword3', keyword3)

        formData.append('genre1', currentGenre)
        formData.append('genre2', currentGenre2)

        formData.append('keywordReason1', keywordReason1)
        formData.append('keywordReason2', keywordReason2)
        formData.append('keywordReason3', keywordReason3)

        // [AS-IS]
        //formData.append('bookIndex', bookTitle)

        // [SBCHOI] Modify variable name
        formData.append('bookIndex', bookIndex)

        if (bookCover) {

            const base64String = bookCover.replace(/^data:image\/[a-zA-Z+]+;base64,/, '');


            const blob = base64ToBlob(base64String, 'image/png');


            const file = blobToFile(blob, 'bookCover.png');
            formData.append('backgroundPhoto', file);
        }

        // 추가 선택 항목
        if (planBackground) formData.append('planningBackground', planBackground);
        if (creativeProcessText) formData.append('creationProcess', creativeProcessText);
        if (differenceFromPrev) formData.append('differenceFromPreviousWork', differenceFromPrev);
        if (readerMessage) formData.append('messageToReaders', readerMessage);
        if (toneDecisionProcess) formData.append('toneDecisionProcess', toneDecisionProcess);

        try {
            setBookRegSubmitButtonClick(true);
            const response = await axios.post('/api/book/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });

            if (response.status === 200) {
                alert("작품 수정이 완료되었습니다.")
                navigate(-1);
            }
        } catch (error) {

            const errorContent = error as any;

            if (errorContent.response && errorContent.response.data) {
                alert(errorContent.response.data);
            } else {
                alert('An unknown error occurred');
            }

        } finally {
            setBookRegSubmitButtonClick(false);
        }


    };

    const base64ToBlob = (base64: string, contentType: string): Blob => {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    };

    const blobToFile = (blob: Blob, fileName: string): File => {
        return new File([blob], fileName, { type: blob.type });
    };

    const checkBookTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setBookTitle(value);
        validateField('title', value);
    };

    const checkAwardBookTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAwardBookTitle(value);
    };

    const handleBookCoverClick = () => {
        fileBookCoverRef.current?.click();
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file ) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            if (typeof reader.result === 'string') {
                const base64String = reader.result;

                const base64Data = base64String.split(',')[1];

                const blob = base64ToBlob(base64Data, file.type);

                const previewUrl = URL.createObjectURL(blob);



                setBookCover(base64String);
                setBookCoverPreview(base64Data);

                setErrors(prev => {
                    const { cover, ...rest } = prev;
                    return rest;
                });
            }
        };
        reader.readAsDataURL(file);

    };




    return(
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="book"
            />

            {/* 히어로 섹션 */}
            <div style={{ background: 'linear-gradient(180deg, #e8f8f0 0%, #edf9f3 40%, #fafafa 100%)' }}
                 className="w-full pt-12 pb-14 md:pt-8 md:pb-10 px-4">
                <div className="max-w-[700px] mx-auto flex flex-col items-center text-center gap-3">
                    <h1 className={`font-bold text-[#222] leading-tight ${isMobile ? 'text-[24px]' : 'text-[32px]'}`}>
                        📝 작품 정보 수정
                    </h1>
                </div>
            </div>

            {/* 폼 카드 영역 */}
            <div className={isMobile ? "flex flex-col px-4 gap-6 py-8 w-full" : "flex justify-center py-12 px-4"}>
                <div className={isMobile ? "" : "w-full max-w-[780px] bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-10"}>

                <form onSubmit={handleSubmit} css={formInputCss} className={isMobile ? "flex flex-col gap-5" : "flex flex-col gap-8"}>


                            <label className="block" id="bookTitle">
                                <div className="flex flex-row">
                                    <p className="title">작품명</p>
                                </div>
                                <div className={"flex flex-col gap-3"}>
                                    <div className="flex-grow ">
                                        <input
                                            className={`appearance-none font-namsan shadow-sm ${isMobile ? "w-full" : "w-[600px]"} h-12 text-[#5E676E] text-base border ${errors.title ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded-2xl py-3 px-4 leading-tight focus:text-black`}

                                            type="text"
                                            placeholder={bookTitle.length === 0 ? '작품명을 입력해 주세요.' : errors.title}
                                            value={bookTitle}
                                            onChange={(e) => {
                                                checkBookTitle(e);
                                            }}
                                        />
                                    </div>
                                    <div className={`flex flex-col items-end ${isMobile ? "w-full" : "w-[600px]"}`}>
                                        <p className="text-gray-600 ">{bookTitle.length}/20</p>
                                    </div>
                                </div>

                                {errors.title &&
                                    <p className="font-namsan font-bold text-red-500">{errors.title}</p>}
                            </label> {/* 작품명 */}


                            <label className="block" id="bookLink">
                                <div className="flex flex-row">
                                    <p className="title">작품 링크 인증</p>
                                </div>
                                <div className="flex flex-col gap-3">
                                    <div className="flex flex-row gap-2">
                                        <input
                                            ref={bookLinkRef}
                                            className={`appearance-none font-namsan shadow-sm ${isMobile ? "w-full" : "w-[600px]"} h-12 text-[#5E676E] text-base border border-extra placeholder-[#5E676E] focus:outline-input rounded-2xl py-3 px-4 leading-tight focus:text-black`}
                                            type="text"
                                            placeholder="구매 사이트 또는 소개 URL을 입력해 주세요."
                                            value={bookLink}
                                            onChange={(e) => {
                                                setBookLink(e.target.value);
                                                setIsUrlVerified(false);
                                                setUrlVerificationMessage(null);
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={handleUrlValidation}
                                            disabled={isVerifyingUrl}
                                            className={`w-[80px] h-12 rounded-2xl font-bold transition-colors ${
                                                isUrlVerified 
                                                ? 'bg-[#EAFBF3] text-main border border-main' 
                                                : 'bg-main text-white'
                                            }`}
                                        >
                                            {isVerifyingUrl ? "..." : "인증"}
                                        </button>
                                    </div>
                                    {urlVerificationMessage && (
                                        <p className={`text-sm font-medium ${urlVerificationMessage.reachable ? 'text-main' : 'text-red-500'}`}>
                                            {urlVerificationMessage.message}
                                        </p>
                                    )}
                                </div>
                            </label> {/* 작품 구매 링크 */}


                                <div className={"flex flex-col gap-3"}>
                                    <div className="flex flex-col gap-2">
                                        <span className="title">해당 작품의 수상 내역</span>
                                        <span
                                            className="text-sm font-namsan text-[#8D8D8D]">*수상 내역이 있을 경우에만 입력해 주세요</span>
                                    </div>
                                    <div className="flex flex-row gap-2 " css={checkboxCss}>
                                        <input
                                            type="checkbox"
                                            id="awardCheck"
                                            className="custom-checkbox"
                                            onChange={() => setNoAward(!noAward)}
                                            checked={noAward}
                                        />
                                        <label htmlFor="awardCheck" className="text-black text-sm">수상 내역 없음</label>
                                    </div>

                                    <div className={"flex flex-col gap-3"}>
                                        <div className="flex-col gap-2 flex ">
                                            <input
                                                ref={titleRef}
                                                className={`appearance-none font-namsan shadow-sm w-[340px] md:w-full h-12 text-[#5E676E] text-base border ${errors.title ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded-2xl py-3 px-4 leading-tight focus:text-black`}

                                                type="text"
                                                placeholder={awardBookTitle.length === 0 ? '수상명 입력하기' : errors.title}
                                                value={awardBookTitle}
                                                onChange={(e) => {
                                                    checkAwardBookTitle(e);
                                                }}
                                                disabled={noAward}
                                            />

                                            <div className="relative w-[340px] md:w-full">
                                                <DatePicker
                                                    selected={awardDate}
                                                    onChange={(date) => setAwardDate(date)}
                                                    dateFormat="yyyy-MM-dd"
                                                    locale={ko}
                                                    placeholderText="수상 날짜 선택하기"
                                                    className="appearance-none font-namsan shadow-sm w-full h-12 text-[#5E676E] text-base border border-extra placeholder-[#5E676E] focus:outline-input rounded-2xl py-3 px-4 leading-tight focus:text-black"
                                                    disabled={noAward}
                                                    renderCustomHeader={({
                                                                             date,
                                                                             decreaseMonth,
                                                                             increaseMonth,
                                                                             prevMonthButtonDisabled,
                                                                             nextMonthButtonDisabled,
                                                                         }) => {
                                                        setVisibleMonth(date);
                                                        return (
                                                            <div className="flex items-center justify-between px-1.5 py-2">
                                                                <button
                                                                    onClick={decreaseMonth}
                                                                    disabled={prevMonthButtonDisabled}
                                                                    className="text-2xl  text-gray-500 hover:text-black disabled:opacity-30"
                                                                >
                                                                    &lt;
                                                                </button>
                                                                <span className="text-lg  text-gray-800">

                                                                      {(() => {
                                                                          const date = new Date('2025-01-01');
                                                                          return date instanceof Date && !isNaN(date.getTime())
                                                                              ? `${date.getFullYear()}년 ${date.getMonth() + 1}월`
                                                                              : 'Invalid Date';
                                                                      })()}

                                                                  </span>
                                                                <button
                                                                    onClick={increaseMonth}
                                                                    disabled={nextMonthButtonDisabled}
                                                                    className="text-2xl  text-gray-500 hover:text-black disabled:opacity-30"
                                                                >
                                                                    &gt;
                                                                </button>
                                                            </div>
                                                        );
                                                    }}
                                                    filterDate={(dateString) => {
                                                        const date = new Date(dateString);
                                                        const visibleDate = new Date(visibleMonth);

                                                        return date instanceof Date && !isNaN(date.getTime()) &&
                                                            date.getFullYear() === visibleDate.getFullYear() &&
                                                            date.getMonth() === visibleDate.getMonth();
                                                    }}

                                                />
                                            </div>


                                        </div>

                                    </div>
                                    {errors.title &&
                                        <p className="font-namsan font-bold text-red-500">{errors.title}</p>}

                                </div>


                          {/* 수상 내역 */}


                            <div className="block">

                                <div className="flex flex-col gap-3">
                                    <p className="title">장르</p>
                                </div>

                                <div className="flex-grow ">
                                    <div className="flex space-x-11">

                                        <div className="flex-1 ">

                                            <div className="relative" ref={dropdownRef}>


                                                <button
                                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                    className="w-[340px] md:w-full  p-3 border-[1px] border-[#19CF74] rounded-2xl text-sm bg-white flex items-center justify-between">
                                                    {currentGenre || currentGenre2
                                                        ? [currentGenre, currentGenre2].filter(Boolean).join(', ')
                                                        : '장르를 선택해 주세요'}
                                                    <Search/>

                                                </button>
                                                {isDropdownOpen && (
                                                    <div
                                                        css={checkboxCss}
                                                        className="absolute w-full h-[256px] p-2 left-0 bg-white border border-gray-300 rounded-lg shadow-md z-10"
                                                    >
                                                        {genre.map((genreItem) => (
                                                            <div key={genreItem}
                                                                 className="flex items-center p-2 hover:bg-[#ADF3D340]">
                                                                <input
                                                                    type="checkbox"
                                                                    id={genreItem}
                                                                    onChange={() => toggleKeyword(genreItem)} // 장르 선택 시 toggleKeyword 호출
                                                                    checked={genreItem === currentGenre || genreItem === currentGenre2} // 선택된 장르 확인
                                                                    className="custom-checkbox flex-shrink-0 w-6 h-6 border-1 border-[#D5D8E2]"
                                                                />
                                                                <label htmlFor={genreItem}
                                                                       className="ml-3 text-gray-800 text-sm">
                                                                    {genreItem}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                            </div>

                                            {errors.genre1 &&
                                                <p className="font-namsan font-bold text-red-500">*최소 1개의 장르는 필수로 선택해야
                                                    합니다</p>}

                                        </div>

                                    </div>
                                </div>


                            </div>{/* 장르 */}


                            <div className={"flex flex-col gap-4"}>
                                <label className="block " id="bookImge">
                                    <div className="flex flex-col gap-2">
                                        <span className="title">표지 업로드</span>
                                        <span
                                            className="text-sm font-namsan text-[#8D8D8D]">*표지는 최대 1MB까지 업로드할 수 있습니다.</span>
                                    </div>

                                </label> {/* bookImge */}

                                <div className="flex flex-col gap-4">
                                    {/* 이미지 프리뷰 */}
                                    <div
                                        className="w-[250px] h-[352px] min-w-[250px] rounded-3xl overflow-hidden border border-extra">
                                        {bookCoverPreview ? (
                                            <img
                                                className="w-full h-full object-cover"
                                                 src={getImageSrc()}
                                                alt="Book Preview"
                                            />
                                        ) : (
                                            <div
                                                className="w-full h-full bg-[#C1C1C1] flex items-center justify-center"/>
                                        )}
                                    </div>

                                    {/* 업로드 버튼 - 오른쪽 하단 정렬 */}
                                    <div className="flex flex-col ">
                                        <button
                                            className="relative w-[250px] h-12 px-8 py-[10px] text-base font-semibold cursor-pointer font-namsan-EB rounded-full bg-main text-white flex items-center justify-center"
                                            type="button"
                                            id="backgroundAdd"
                                        >
                                            <input
                                                ref={fileBookCoverRef}
                                                className="absolute top-0 left-0 opacity-0 w-full h-full cursor-pointer"
                                                type="file"
                                                id="backgroundFileInput"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                            <span>업로드</span>
                                        </button>
                                    </div>
                                </div>


                                {errors.cover &&
                                    <p className="text-red-500 font-namsan mt-2 ml-12 font-semibold">{errors.cover}</p>}
                            </div>
                            {/* 표지 업로드 */}


                            <label className="block  " id="bookDescription">
                                <div className="flex flex-row">
                                    <p className="title">작품을 더 자세히 설명해 주세요!</p>
                                </div>
                                <div className="flex-grow ">
                                <textarea
                                    ref={descRef}
                                    className={`appearance-none w-full h-52 font-namsan border ${errors.desc ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}

                                    value={bookDescription}
                                    onChange={(e) => {
                                        setBookDescription(e.target.value);
                                        validateField('desc', e.target.value);
                                    }}
                                    placeholder={errors.desc || '책에 대한 내용을 입력해 주세요.'}
                                    maxLength={500}
                                />
                                    <div className={"flex flex-col items-end "}>
                                        <p className="text-gray-600 ">{bookDescription.length}/500</p>
                                    </div>
                                </div>
                                {errors.desc &&
                                    <p className="text-red-500 font-namsan mt-2  font-semibold">{errors.desc}</p>}
                            </label> {/*책 설명*/}


                            <label className="block  " id="catalyst">
                                <div className="flex flex-row">
                                    <p className={isMobile ? "text-base font-bold text-black" : "title"}>작품의 출간 계기를 들려주세요.</p>
                                </div>
                                <div className="flex-grow ">
                                <textarea
                                    ref={catalystRef}
                                    className={`appearance-none w-full h-52 font-namsan border ${errors.catalyst ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black mb-3`}
                                                                    value={catalyst}
                                    onChange={(e) => {
                                        setCatalyst(e.target.value);
                                        validateField('catalyst', e.target.value);
                                    }}
                                    placeholder={errors.catalyst || '해당 책에 대한 작가님의 출간 계기를 들려주세요.'}
                                    maxLength={150}
                                />
                                    <div className={"flex flex-col items-end "}>
                                        <p className="text-gray-600 ">{bookDescription.length}/150</p>
                                    </div>
                                </div>
                                {errors.catalyst &&
                                    <p className="text-red-500 font-namsan mt-2 font-semibold">{errors.catalyst}</p>}
                            </label> {/*출간 계기*/}


                            <div className={"flex flex-col gap-3"}>
                                <label className="block  " id="keyword1">
                                    <div className="flex flex-row  ">
                                        <p className={isMobile ? "text-base font-bold text-black" : "title"}>책을 잘 표현하는 <span className={isMobile ? "text-main" : "point"}>키워드 3가지</span>를 선정해 주세요</p>
                                    </div>

                                    <div className={"flex flex-col gap-4"}>
                                        <div className="flex flex-col ">

                                            <p className={isMobile ? "font-semibold text-black text-base" : "font-semibold text-black text-2xl"}>첫 번째 키워드</p>

                                            <input
                                                ref={keywordRef1}
                                                className={` appearance-none h-12 w-[340px] md:w-full  font-namsan border ${errors.keyword1 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}
                                                maxLength={10}
                                                type="text"
                                                placeholder={errors.keyword1 || '키워드를 입력해 주세요.'}
                                                value={keyword1}
                                                onChange={checkKeyWord(1)}
                                            />

                                            {errors.keyword1 &&
                                                <p className="text-red-500 font-namsan  font-semibold">{errors.keyword1}</p>}

                                        </div>

                                        <div className="flex-grow gap-2 mt-4">
                                            <p className={isMobile ? "font-semibold text-black text-base" : "subTitle"}>해당 키워드를 선정한 이유는 무엇인가요?</p>
                                            <textarea
                                                ref={keywordResRef1}
                                                className={`appearance-none w-full h-52 font-namsan border ${errors.keywordRes1 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}

                                                 value={keywordReason1}
                                                 onChange={(e) => {
                                                     setKeywordReason1(e.target.value);
                                                     validateField('keywordRes1', e.target.value);
                                                 }}
                                                 placeholder={errors.keywordRes1 || '최대 200자 내외로 작성해 주세요.'}
                                                maxLength={200}
                                            />
                                            <div className={"flex flex-col items-end "}>
                                                <p className="text-gray-600 ">{keywordReason1.length}/200</p>
                                            </div>
                                            {errors.keywordRes1 &&
                                                <p className="text-red-500 font-namsan mt-2  font-semibold">{errors.keywordRes1}</p>}
                                        </div>


                                    </div>


                                    <div className={"flex flex-col gap-4"}>
                                        <div className="flex flex-col ">

                                            <p className={isMobile ? "font-semibold text-black text-base" : "font-semibold text-black text-2xl"}>두 번째 키워드</p>

                                            <input
                                                ref={keywordRef2}
                                                className={` appearance-none h-12 w-[340px] md:w-full  font-namsan border ${errors.keyword2 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}
                                                maxLength={10}
                                                type="text"
                                                placeholder={errors.keyword2 || '키워드를 입력해 주세요.'}
                                                value={keyword2}
                                                onChange={checkKeyWord(2)}
                                            />

                                            {errors.keyword2 &&
                                                <p className="text-red-500 font-namsan  font-semibold">{errors.keyword2}</p>}

                                        </div>

                                        <div className="flex-grow gap-2 mt-4">
                                            <p className={isMobile ? "font-semibold text-black text-base" : "subTitle"}>해당 키워드를 선정한 이유는 무엇인가요?</p>
                                            <textarea
                                                ref={keywordResRef2}
                                                className={`appearance-none w-full h-52 font-namsan border ${errors.keywordRes2 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}

                                                 value={keywordReason2}
                                                 onChange={(e) => {
                                                     setKeywordReason2(e.target.value);
                                                     validateField('keywordRes2', e.target.value);
                                                 }}
                                                 placeholder={errors.keywordRes2 || '최대 200자 내외로 작성해 주세요.'}
                                                maxLength={200}
                                            />
                                            <div className={"flex flex-col items-end "}>
                                                <p className="text-gray-600 ">{keywordReason2.length}/200</p>
                                            </div>
                                            {errors.keywordRes2 &&
                                                <p className="text-red-500 font-namsan mt-2  font-semibold">{errors.keywordRes2}</p>}
                                        </div>


                                    </div>


                                    <div className={"flex flex-col gap-4"}>
                                        <div className="flex flex-col ">

                                            <p className={isMobile ? "font-semibold text-black text-base" : "font-semibold text-black text-2xl"}>세 번째 키워드</p>

                                            <input
                                                ref={keywordRef3}
                                                className={` appearance-none h-12 w-[340px] md:w-full  font-namsan border ${errors.keyword3 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}
                                                maxLength={10}
                                                type="text"
                                                placeholder={errors.keyword3 || '키워드를 입력해 주세요.'}
                                                value={keyword3}
                                                onChange={checkKeyWord(3)}
                                            />

                                            {errors.keyword3 &&
                                                <p className="text-red-500 font-namsan  font-semibold">{errors.keyword3}</p>}

                                        </div>

                                        <div className="flex-grow gap-2 mt-4">
                                            <p className={isMobile ? "font-semibold text-black text-base" : "subTitle"}>해당 키워드를 선정한 이유는 무엇인가요?</p>
                                            <textarea
                                                ref={keywordResRef3}
                                                className={`appearance-none w-full h-52 font-namsan border ${errors.keywordRes3 ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}

                                                 value={keywordReason3}
                                                 onChange={(e) => {
                                                     setKeywordReason3(e.target.value);
                                                     validateField('keywordRes3', e.target.value);
                                                 }}
                                                 placeholder={errors.keywordRes3 || '최대 200자 내외로 작성해 주세요.'}
                                                maxLength={200}
                                            />
                                            <div className={"flex flex-col items-end "}>
                                                <p className="text-gray-600 ">{keywordReason3.length}/200</p>
                                            </div>
                                            {errors.keywordRes3 &&
                                                <p className="text-red-500 font-namsan mt-2  font-semibold">{errors.keywordRes3}</p>}
                                        </div>


                                    </div>


                                </label> {/*keyword*/}
                            </div>

                            <label className="block  " id="bookIndex">

                                <div className="flex flex-row">
                                    <p className="title">목차를 입력해 주세요</p>
                                </div>

                                <div className="flex-grow ">
                                <textarea
                                    ref={indexRef}
                                    className={`appearance-none w-full h-52 font-namsan border ${errors.index ? 'border-red-500 placeholder-red-500 focus:outline-red-500' : 'border-extra placeholder-[#5E676E] focus:outline-input'} rounded py-3 px-4 leading-tight  focus:text-black `}

                                     value={bookIndex}
                                     onChange={(e) => {
                                         setBookIndex(e.target.value);
                                         validateField('index', e.target.value);
                                     }}
                                     placeholder={errors.index || '목차를 입력해 주세요.'}
                                    maxLength={500}
                                />
                                </div>
                                <div className={"flex flex-col items-end "}>
                                    <p className="text-gray-600 ">{bookIndex.length}/500</p>
                                </div>
                                {errors.index &&
                                    <p className="text-red-500 font-namsan mt-2  font-semibold">{errors.index}</p>}
                            </label> {/*책 설명*/}

                            {/* ───── 추가 선택 항목 ───── */}
                            <BookOptionalSection
                                desktop={!isMobile}
                                planBackground={planBackground}
                                setPlanBackground={setPlanBackground}
                                creativeProcessText={creativeProcessText}
                                setCreativeProcessText={setCreativeProcessText}
                                differenceFromPrev={differenceFromPrev}
                                setDifferenceFromPrev={setDifferenceFromPrev}
                                readerMessage={readerMessage}
                                setReaderMessage={setReaderMessage}
                                toneDecisionProcess={toneDecisionProcess}
                                setToneDecisionProcess={setToneDecisionProcess}
                            />



                            <div className="flex flex-col items-center justify-center gap-3 mt-6">
                                <button
                                    className="w-full h-[52px] font-bold bg-white text-[#19cf7a] border border-[#19cf7a] hover:bg-[#f0fdf6] text-[16px] rounded-full transition-colors"
                                    type="button"
                                    onClick={() => {
                                        window.scrollTo({
                                            top: 0,
                                            behavior: 'smooth'
                                        });
                                    }}
                                >
                                    맨 위에서부터 다시 검토!
                                </button>
                                <button
                                    className="w-full h-[52px] bg-[#19cf7a] font-bold hover:bg-[#00b368] text-white text-[16px] rounded-full shadow-[0px_4px_6px_rgba(25,207,122,0.2)] transition-colors"
                                    type="submit"
                                >
                                    {bookRegSubmitButtonClick ? "제출중..." : "작품 수정하기"}
                                </button>
                                <button
                                    className="w-full h-[52px] font-bold bg-white text-[#5E676E] border border-extra hover:bg-[#f8f9fa] text-[16px] rounded-full transition-colors"
                                    type="button"
                                    onClick={() => navigate(-1)}
                                >
                                    작품 상세 페이지로 돌아가기
                                </button>
                            </div>

                        </form>
                    </div>
                </div>

                <Footer/>
            </div>


    )



}

export default BookUpdate;
